import React from "react";
import MultiEditingPicker from "./index";
import { Context } from "@routes/private/Editor/Context";

const MultiEditingPickerConsumer: React.FC = () => {

  return (
    <Context.Consumer>
      {
        ({
          data,
          multiEditingConfig,
          editorStatus,
          selectDescribe,
          onSelectorActive,
          onSetsChange,
          onCommandChange,
          onMultiEditingFocus,
        }) =>
          <MultiEditingPicker
            data={data}
            multiEditingConfig={multiEditingConfig}
            editorStatus={editorStatus}
            selectDescribe={selectDescribe}
            onSelectorActive={onSelectorActive}
            onSetsChange={onSetsChange}
            onCommandChange={onCommandChange}
            onMultiEditingFocus={onMultiEditingFocus}
          />
      }
    </Context.Consumer>
  )
}

export default MultiEditingPickerConsumer;